import React, { FC } from 'react';
import { TerritorySidebarButton } from './TerritorySidebarButton';
import { useTerritoryActiveTab } from './hooks/useTerritoryActiveTab';
import { TerritorySelectedTab } from './constants';
import { TerritoryTabList } from './TerritoryTabList';
import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';

type TTerritoryTabContainerProps = {
  territoryName: string;
  onClick: () => void;
  isSidebarOpen?: boolean;
  territoryVersion: TerritoryVersionType;
};

export const TerritoryTabContainer: FC<TTerritoryTabContainerProps> = ({
  territoryName,
  onClick,
  isSidebarOpen,
  territoryVersion,
}) => {
  const { activeTab, openTerritoryTab } = useTerritoryActiveTab();

  const { sendEvent } = useAnalytics();

  const onTabClick = (tab: TerritorySelectedTab) => {
    openTerritoryTab(tab);
    sendEvent('territory_tab_click', { tab_name: tab });
  };

  return (
    <div className="flex pt-3 items-center gap-4">
      <div className="hidden md:block">
        <TerritorySidebarButton onClick={onClick} isOpen={isSidebarOpen} />
      </div>
      <TerritoryTabList
        activeTab={activeTab}
        onClick={onTabClick}
        isSidebarOpen={isSidebarOpen}
        territoryName={territoryName}
        territoryVersion={territoryVersion}
      />
    </div>
  );
};
